module.exports = "#logo{\n  margin-top: 5px;\n  max-height: 100%;\n  max-width: 100%;\n  margin-left:auto;\n  margin-right:auto;      \n}"